// Campo que abre a conta pelo número da mesa.
import React from "react";
import * as Styles from "../../styles/PointOfSale.styles";

export const BuscaDeMesa: React.FC<{
  component: any;
  componentProps: any;
  buttonLabel: any;
  searchValueInput: string;
  setSearchValueInput: (valor: string) => void;
  searchInputRefType1: React.RefObject<HTMLInputElement>;
  handleSearch: (openNewOrder?: boolean, productExpanded?: boolean) => void;
  setComponent: () => void;
}> = ({
  component,
  componentProps,
  buttonLabel,
  searchValueInput,
  setSearchValueInput,
  searchInputRefType1,
  handleSearch,
  setComponent,
}) => {
  return (
    <Styles.Search
      selected={Boolean(component.componentSelected)}
      componentPosition={componentProps.componentPosition}
      componentBrightness={String(componentProps.componentBrightness)}
      componentStatus={String(componentProps.componentStatus)}
      componentColor={String(componentProps.componentColor)}
      componentHeight={String(componentProps.componentHeight)}
      componentWidth={String(componentProps.componentWidth)}
    >
      {component.componentSelected && (
        <Styles.SelectedIcon
          top={component.componentProps.componentPosition.y}
          left={component.componentProps.componentPosition.x}
        >
          zoom_out_map
        </Styles.SelectedIcon>
      )}
      <Styles.SearchInput
        ref={searchInputRefType1}
        id={component.componentId}
        componentWidth="50%"
        defaultValue={searchValueInput}
        onChange={(e: any) => {
          // Permite apenas números
          const value = e.target.value.replace(/[^0-9]/g, "");
          setSearchValueInput(value);
        }}
        onKeyDown={(e: any) => {
          // Permite apenas teclas de números e controle
          if (
            !(
              (e.key >= "0" && e.key <= "9") ||
              ["Backspace", "Delete", "ArrowLeft", "ArrowRight", "Tab"].includes(e.key)
            )
          ) {
            e.preventDefault();
          }
        }}
        onBlur={() => {
          setComponent();
        }}
        placeholder={String(componentProps.componentInputPlaceholder)}
        autoComplete="off"
      />
      <Styles.SearchButton
        componentWidth="50%"
        componentBackgroundColor={String(
          componentProps.componentBackgroundColor
        )}
        onClick={() => {
          handleSearch();
        }}
      >
        <Styles.SearchIcon>search</Styles.SearchIcon>
        {componentProps.componentShortcut !== "" ? (
          <>
            <span className="buttonLabel">Buscar</span>
            <Styles.Divider orientation={"vertical"} />
            <span className="shortcut">
              {componentProps.componentShortcut}
            </span>
          </>
        ) : (
          <>
            <span className="buttonLabel">Buscar</span>
          </>
        )}
      </Styles.SearchButton>
    </Styles.Search>
  );
};
